import { Associations } from 'backbone-associations'

export default class CanonicalCategory extends Associations.AssociatedModel {}
